import PropTypes from 'prop-types'
import CommunicationBoardCard from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/CommunicationBoardCard'

const CommunicationBoardList = ({ sections, visibleSections, t, hidden }) => {
  if (hidden) return null

  return visibleSections.map(sectionKey => {
    const sectionData = sections.find(s => s.section === sectionKey)
    if (!sectionData) return null
    return <CommunicationBoardCard key={sectionKey} sectionKey={sectionKey} sectionData={sectionData} t={t} />
  })
}

CommunicationBoardList.propTypes = {
  sections: PropTypes.array.isRequired,
  visibleSections: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  hidden: PropTypes.bool.isRequired,
}

export default CommunicationBoardList
